<template>
  <CustomModal id="select-assignment-modal"
               class="basic-modal select-assignment-modal"
               :title="$t('reports.select_assignments')"
               :ok-title="$t('common.confirm')"
               :close-title="$t('common.cancel')"
               :ok-disabled="okDisabled"
               @ok="applySelectedList()"
               @cancel="$emit('cancel')">
    <div class="select-assignment-modal__body">
      <!-- select all -->
      <div class="select-assignment-modal__checkbox-row select-assignment-modal__select-all-row">
        <Checkbox @change="selectAllAssignments" :model-value="isAll" :check-value="true">
          <span slot="label" class="ml-3 typography--body-3">
            {{ $t('reports.select_all_assignments') }}
          </span>
        </Checkbox>

        <div class="float-right typography--caption typography--color-secondary mt-1">
          {{ $t('reports.select_all_assignments_help') }}
        </div>
      </div>

      <!-- select each -->
      <div>
        <div v-for="assignment in assignmentList" :key="assignment.id" class="select-assignment-modal__checkbox-row">
          <Checkbox @change="selectAssignment" :model-value="selectedList" :check-value="assignment.id" :disabled="isAll">
            <span slot="label" class="ml-3 typography--body-3">
              {{ assignment.assigned_card.title }}
            </span>
          </Checkbox>
        </div>
      </div>
    </div>
  </CustomModal>
</template>

<script>
  import { map } from 'lodash';

  export default {
    name: 'select-assignment-modal',

    props: {
      assignmentList: {
        type: Array,
        default: () => ([]),
      },
      preSelectedList: {
        type: Array,
        default: () => ([]),
      },
      hasSelectedAllAssignments: {
        type: Boolean,
        default: true,
      },
    },

    data() {
      return {
        isAll: true,
        selectedList: [],
      };
    },

    computed: {
      okDisabled() {
        return !this.isAll && this.selectedList.length === 0;
      },
    },

    methods: {
      applySelectedList() {
        this.$emit('assignments-selected', { selectedList: this.selectedList, isAll: this.isAll });
      },

      selectAllAssignments(isAll) {
        this.selectedList = [];
        this.isAll = isAll;
      },

      selectAssignment(checkedList) {
        this.selectedList = checkedList;
      },
    },

    created() {
      this.isAll = this.hasSelectedAllAssignments;

      if (!this.isAll) {
        this.selectedList = map(this.preSelectedList, 'id');
      }
    },
  };
</script>

<style lang="scss" scoped>
  .select-assignment-modal__body {
    overflow-y: scroll;
    height: 354px;
  }

  .select-assignment-modal__select-all-row {
    margin-bottom: 28px;
  }

  .select-assignment-modal__checkbox-row {
    padding-top: 8px;
    padding-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/app/classes/components/SelectAssignmentModal.vue